var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification",class:{
        'show': _vm.show
     }},[_c('h3',{staticClass:"notification__title"},[_vm._v(_vm._s(_vm.message.title))]),_c('div',{staticClass:"notification__message"},[_vm._v(_vm._s(_vm.message.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }